module.exports = __webpack_public_path__ + "img/CORONA_MAL_ESTADO.png";